import "regenerator-runtime/runtime";
import React from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import "@momentum-ui/web-components/dist/comp/md-task-item";
import "@momentum-ui/web-components/dist/comp/md-theme";
import TaskList from "./TaskList";
import styles from "./taskList.module.css";
import Collapsible from "../Collapsible";
import { useTaskListStore } from "../../Store";
import { i18n } from '../../utils/GadgetUtils';

const TaskPane = (props) => {
  const [state, setState] = useTaskListStore();

  const collapsibleShortcutKeyConfig = {
    shortcutKeyId: 'cisco_imi_tasklist_exapndcollapse',
    shortcutKey: i18n.getMsg('gadget.imi.collapsible.tasklist.action.key.t'),
    shortcutKeyAction: i18n.getMsg('gadget.imi.collapsible.tasklist.action'),
    modifierKeys: window.finesse.shortcutkey.ShortcutKeyService.CONSTANTS.MODIFIER_KEYS.CTRL_ALT,
    componentName: i18n.getMsg('gadget.imi.collapsible.tasklist.componentname')
  };

  return (
    <div style={{ height: "100%", background: "#FFFFFF" }}>
      <Collapsible width="328px" buttonClass={`${styles["taskpane-collapsible-btn"]}`} shortcutKeyConfig={collapsibleShortcutKeyConfig} displayOnHover={true}>
        <div id={`${styles["taskPane-container"]}`}>
          <md-theme lumos class={`${styles["task-md-theme"]}`}>
            <TaskList setConversationLoader={props.setConversationLoader} taskItems={state.taskList} setErrorAfterTaskLoad={props.setErrorAfterTaskLoad} />
          </md-theme>
        </div>
      </Collapsible>
    </div>
  );
};

TaskPane.propTypes = {
  taskItems: PropTypes.array,
};

export default TaskPane;
